import { css } from '@emotion/core';

export const datePickerFieldStyle = css`
  max-width: 100% !important;
`;
